import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NowcastConstants } from './nowcast.constant';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-nowcast-dashboard',
  templateUrl: './nowcast-dashboard.component.html',
  styleUrls: ['./nowcast-dashboard.component.scss']
})
export class NowcastDashboardComponent implements OnInit, OnDestroy {
  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();

  stateUrlId: string;
  adminselected: string;
  selected: string;
  selectedValue: string;
  sourceOptions: any;
  adminSelected: boolean;
  radarSourceArray = [];
  radarSourceArraySubscription: any;
  activeRadioList: boolean[] = [];
  blockArraySubscription: any;
  six_hour_blocks: object;
  stationWarningsDisable: boolean = true;
  showFullScreenView;
  selectedSeamlessSource: any = 'IMD_RADAR_MODEL_INPUT_NOWCAST'
  options = {
    IMD_RADAR_MODEL_INPUT_NOWCAST: 'RADAR',
    CTT_MODEL_INPUT_NOWCAST: 'CTT',
    EUMETSAT_MODEL_INPUT_NOWCAST: 'EUMETSAT',
    MODEL_INPUT_NOWCAST: 'RAINFALL',
  };
  orderedOptions: { key: string, value: string }[] = [];
  checkboxList = [
    { label: 'AP CATCHMENTS', checked: true },
    { label: 'OD CATCHMENTS', checked: true },
    { label: 'TN CATCHMENTS', checked: true }
  ];
  

  constructor(private router: Router, private route: ActivatedRoute,
    private utils: UtilsService) {
    for (const key in ProjConstants.IDTOUUIDMAPPING) {
      if (!ProjConstants.IDTOUUIDMAPPING.hasOwnProperty(this.route.snapshot.paramMap.get('id'))) {
        router.navigate(['*']);
      }
    }
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
    ProjConstants.STATENAME = this.utils.getStateName(this.stateUrlId);
    const temp = this.utils.getAdminBasinToggle().subscribe(
      data => {
        this.adminSelected = data;
      });
    temp.unsubscribe();
    this.adminSelected = true;
  }

  ngOnInit() {
    const url = this.router.url;
    const urlparams = url.split('/');
    this.selected = urlparams[2];
    this.selectedValue = NowcastConstants[NowcastConstants.COMPONENTSOURCEMAPPING[this.selected]].default;
    this.sourceOptions = NowcastConstants[NowcastConstants.COMPONENTSOURCEMAPPING[this.selected]].sourceList;
    this.addSubscriptions();
    this.utils.getShowFullScreenView().subscribe(async source => {
      this.showFullScreenView = source;
      if (!this.showFullScreenView) {
        this.sourceChange(this.selectedValue, true)
      }
      else {
        this.sourceChange(this.selectedValue, false)
      }
    })
    this.utils.getNowcastView().subscribe(view => {
      if (view) {
        this.initializeActiveRadioList(this.selectedValue);
      }
    });

    this.orderedOptions = Object.keys(this.options).map(key => {
      return { key: key, value: this.options[key] };
    });
  }

  ngOnChanges(change: SimpleChanges) {
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }
    }
    this.updateActiveRadioList();
  }
  updateActiveRadioList() {
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < 12; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }
  initializeActiveRadioList(source) {
    if (source != 'RICKEN') {
      this.blockNum = 5
    } else {
      this.blockNum = 0
    }
    this.updateActiveRadioList()
  }

  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
    }
    this.utils.setIndex(this.labelStrings[blockNumber]['groupName']);
  }

  showLayer(blockNumber) {
    this.blockArraySubscription = this.utils.getBlocksArray().subscribe(value => {
      this.six_hour_blocks = value;
      this.utils.setIndex(this.labelStrings[blockNumber]['groupName']);
      this.utils.getSRLRToggle().subscribe(value => {
        if (value === true) {
          this.utils.setTimestamp(ProjConstants.INDEX_TO_TIMESTAMP_MAPPING[blockNumber.toString()]);
        } else {
          this.utils.setTimestamp(ProjConstants.INDEX_TO_TIMESTAMP_MAPPING_LR[blockNumber.toString()]);
        }
      });
    });
  }
  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['label']['label'];
    }
  }
  isObservedWeather(index: number): boolean {
    return index < 6;
  }

  showWeatherLabel(index: number): boolean {
    return this.selectedValue !== 'RICKEN';
  }


  ngOnDestroy() {
    if (!isNullOrUndefined(this.radarSourceArraySubscription)) {
      this.radarSourceArraySubscription.unsubscribe();
    }
    this.utils.setRadarCTCSrc(null);
  }

  adminBasinToggle() {
    this.adminSelected = !this.adminSelected;
    this.utils.setAdminBasinToggle(this.adminSelected);
  }

  addSubscriptions() {
    this.utils.getRadarCTCSrc().subscribe((data: any) => {
      if (!isNullOrUndefined(data)) {
        if (data == 'RADAR+CTT') {
          // this.stationWarningsDisable = false
          const url = this.router.url;
          const urlparams = url.split('/');
          this.selected = urlparams[2];
          // if (this.selected = 'RADAR+CTT') {
          //   this.selected = 'RADAR+CTT';
          this.selectedValue = 'RADAR+CTT'
          // }
          // this.selectedValue = NowcastConstants[NowcastConstants.COMPONENTSOURCEMAPPING[this.selected]].default;
          // this.sourceOptions = [NowcastConstants[NowcastConstants.COMPONENTSOURCEMAPPING[this.selected]].sourceList[3]];
          // this.sourceOptions = NowcastConstants[NowcastConstants.COMPONENTSOURCEMAPPING[this.selected]].sourceList;
          // this.sourceChange(this.selectedValue)
        } else {
          this.selectedValue = NowcastConstants[NowcastConstants.COMPONENTSOURCEMAPPING[this.selected]].default;
          this.sourceOptions = NowcastConstants[NowcastConstants.COMPONENTSOURCEMAPPING[this.selected]].sourceList;
        }
      } else {
        this.selectedValue = NowcastConstants[NowcastConstants.COMPONENTSOURCEMAPPING[this.selected]].default;
        this.sourceOptions = NowcastConstants[NowcastConstants.COMPONENTSOURCEMAPPING[this.selected]].sourceList;
      }
    })
    this.radarSourceArraySubscription = this.utils.getRadarSourceArray().subscribe(data => {
      this.radarSourceArray = [...data];
    });
  }

  sourceChange(data: any, bool: any) {
    // console.log(data);
    // if(data != 'RADAR+CTT') {
    this.selectedValue = data;
    // } else {
    //   this.selectedValue = 'RADAR+CTT'
    // }
    if (this.selected === 'cloudcover') {
      this.utils.setCCsourceData(this.selectedValue);
    } else if (this.selected === 'cloudtemperature') {
      this.utils.setCTsourceData(this.selectedValue);
    } else if (this.selected === 'districtwarnings') {
      this.utils.setDWsourceData(this.selectedValue);
    } else if (this.selected === 'stationwarnings') {
      this.utils.setSWsourceData(this.selectedValue);
    } else if (this.selected === 'nowcast') {
      // this.utils.setSWsourceData(this.selectedValue);
      this.utils.setRadarSourceData(this.selectedValue);
      this.initializeActiveRadioList(this.selectedValue)
    }
    // let fullScreenView:any = this.utils.getVal();
    if (this.selectedValue == 'CUSTOM' && bool) {
      this.utils.setVal(false);
      this.router.navigate(['', 'nowcastweather', 'radar-forecast', 'akbm'])
    }
    // if((this.selectedValue == 'RADAR+CTT') && bool && data != 'RADAR+CTT CUSTOM'){
    //   // this.utils.setVal(false);
    //   this.router.navigate(['', 'nowcastweather', 'forecast', 'akbm'])
    // }
    // if((this.selectedValue == 'RADAR+CTT') && bool && data == 'RADAR+CTT CUSTOM'){
    //   // this.utils.setVal(false);
    //   this.router.navigate(['', 'nowcastweather', 'radar-forecast', 'akbm'])
    // }
  }

  checkIfListIncludes(list: any[], value: any) {
    return list.includes(value);
  }

  updateSourceArrayList(list: any[], value: any, type: any) {
    if (list.includes(value)) {
      list.splice(list.indexOf(value), 1);
    } else if (!(list.includes(value))) {
      list.push(value);
    }

    if (type === 'radar') {
      this.utils.setRadarSourceArray(list);
    }
  }

  selectAdmin() {
    console.log("adminigng")
    this.adminSelected = true;
    this.utils.setAdminBasinToggle(this.adminSelected);
  }

  onSeamlessSourceChange() {
    this.utils.setSeamlessviewSource(this.selectedSeamlessSource)
  }

  onCheckboxChange(item,event) {
    let obj = {
      layerName: item.label,
      checked: event.target.checked
    }
    this.utils.catchmentLayers.next(obj)
  }

}
